// English fallback. Mantem o mesmo shape do `pt-BR.ts` (TypeScript valida via
// `Translations`). Traducao real e parcial — produto nao oferece i18n
// completo nesta versao; en serve como fallback estrutural caso o detector
// caia em locale nao mapeado.

import type { Translations } from './pt-BR';

export const en: Translations = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    loading: 'Loading...',
    retry: 'Try again',
    search: 'Search',
    error: {
      generic: 'Something went wrong. Please try again.',
      network: 'No connection. Please check your internet.',
      unauthorized: 'Your session has expired. Please sign in again.',
      notFound: 'We could not find what you are looking for.',
      validation: 'Please check the form fields.',
    },
    offline: 'You are offline. Some actions may be unavailable.',
    appName: 'Grana Money',
  },
  nav: {
    home: 'Home',
    groups: 'Groups',
    reports: 'Reports',
    profile: 'Profile',
    notifications: 'Notifications',
    transactions: 'Transactions',
    expenses: 'Expenses',
    incomes: 'Income',
    budgets: 'Budgets',
    forecasts: 'Forecasts',
    settings: 'Settings',
    logout: 'Sign out',
  },
  auth: {
    welcome: {
      brand: 'Grana Money',
      headline: 'Start now. Your finances, under control.',
      subhead: 'Create your account in less than a minute and invite your family group.',
      ctaPrimary: 'Create free account',
      ctaSecondary: 'I already have an account · Sign in',
      slides: {
        s1Tag: 'CHAPTER 01',
        s1Title: 'Money that breathes together.',
        s1Sub:
          'Grana Money brings personal and family finances into a single view. No spreadsheets, no friction.',
        s2Tag: 'CHAPTER 02',
        s2Title: 'Every income matters.',
        s2Sub:
          'Log income in seconds and watch your balance grow. Crystal clarity for every penny.',
        s3Tag: 'CHAPTER 03',
        s3Title: 'Anticipate, never be surprised.',
        s3Sub: 'Reports and projections keep you a step ahead. A budget that adapts to your pace.',
      },
      pillars: {
        secure: 'Secure',
        secureDesc: 'End-to-end encryption',
        free: 'Free',
        freeDesc: 'Base plan at no cost',
      },
      skip: 'Skip',
    },
    login: {
      title: 'Sign in',
      subtitle: 'Welcome back. Pick up where you left off.',
      email: 'Email',
      password: 'Password',
      submit: 'Sign in',
      forgot: 'Forgot your password?',
      noAccount: "Don't have an account?",
      registerCta: 'Create account',
      rememberMe: 'Remember me',
      orContinueWith: 'or continue with',
      googleCta: 'Google · soon',
      appleCta: 'Apple · soon',
      socialSoon: 'Social sign-in is coming soon.',
      errors: {
        invalid: 'Invalid email or password.',
        rateLimited: 'Too many attempts. Try again in a few minutes.',
        accountDisabled: 'This account is disabled. Please contact support.',
      },
    },
    register: {
      title: 'Create account',
      stepLabel: 'Step {{current}} of {{total}}',
      name: 'Full name',
      namePlaceholder: 'How should we call you?',
      email: 'Email',
      emailPlaceholder: 'you@example.com',
      password: 'Password',
      passwordPlaceholder: 'Create a strong password',
      confirmPassword: 'Confirm password',
      submit: 'Create account',
      hasAccount: 'Already have an account?',
      loginCta: 'Sign in',
      next: 'Next',
      back: 'Back',
      stepHints: {
        s1: 'Use your real name to personalize the group experience.',
        s2: "We'll send a verification link to this email.",
        s3: 'Your password must satisfy the rules below.',
      },
      errors: {
        emailExists: 'This email is already registered.',
      },
    },
    forgotPassword: {
      title: 'Recover password',
      description: 'Enter your registered email and we will send instructions.',
      method: 'How do you prefer to receive?',
      methodEmail: 'Email',
      methodSms: 'SMS',
      submit: 'Send instructions',
      backToLogin: 'Back to sign in',
      success: 'If an account exists, you will receive a message shortly.',
    },
    resetPassword: {
      title: 'Reset password',
      description: 'Create a new and secure password for your account.',
      tokenLabel: 'Code',
      tokenPlaceholder: 'Paste the code you received',
      tokenVerified: 'Link verified',
      tokenManualHint: "Didn't get the link? Paste the code manually.",
      newPassword: 'New password',
      newPasswordPlaceholder: 'Create a strong password',
      submit: 'Reset password',
      success: 'Password reset successfully.',
      errors: {
        invalidToken: 'Invalid or expired link.',
      },
    },
  },
  transactions: {
    new: 'New transaction',
    expense: 'Expense',
    income: 'Income',
    amount: 'Amount',
    description: 'Description',
    category: 'Category',
    date: 'Date',
  },
};
